import { render, staticRenderFns } from "./Product400Page.vue?vue&type=template&id=12f00a44"
import script from "./Product400Page.vue?vue&type=script&lang=js"
export * from "./Product400Page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports